<template>
  <div>
    <div class="list-option">
      <div>
        <div class="service-option">
          <div class="title-option">option</div>
          <div class="title-option">ราคาขาย</div>
        </div>
        <div
          class="group-option"
          v-for="(serviceOption, serviceIndex) in packageOptions"
          :key="serviceIndex"
        >
          <div class="grid-price">
            <div class="title-option-head">
              {{ serviceOption.serviceTitle }}
            </div>
            <div class="title-option-price" v-if="serviceOption.servicePrice">
              {{ serviceOption.servicePrice }}
            </div>
          </div>
          <div v-if="serviceOption.serviceVariants">
            <div
              class="service-variant"
              v-for="(
                serviceVariant, serviceVariantIndex
              ) in serviceOption.serviceVariants"
              :key="serviceVariantIndex"
            >
              <div
                v-for="(variant, variantIndex) in serviceVariant.variants"
                :key="variantIndex"
              >
                <div v-if="!variant.isNotSale">
                  <div v-if="!variant.isExtraOption" class="grid-price">
                    <div>
                      <input
                        class="radio-option"
                        type="radio"
                        :value="true"
                        :name="serviceOption.serviceTitle"
                        :checked="variant.isVaraintSelected"
                        @change="
                          handleSelectMainVariant(
                            serviceOption.serviceId,
                            serviceVariant.id,
                            variant.id
                          )
                        "
                      />{{ variant.title }}
                    </div>
                    <div class="title-option-detail">{{ variant.price }}</div>
                  </div>

                  <div v-if="variant.isExtraOption" class="grid-price">
                    <div>
                      <el-checkbox
                        class="checkbox-variant"
                        :value="variant.isVaraintSelected"
                        @change="
                          handleSelectExtraVariant(
                            $event,
                            serviceOption.serviceId,
                            serviceVariant.id,
                            variant.id
                          )
                        "
                        >{{ variant.title }}</el-checkbox
                      >
                    </div>
                    <div class="title-option-detail">+ {{ variant.price }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="title-head-package">
        <div>สรุป</div>
        <service-list-item
          class="service"
          v-for="service in services"
          v-bind="service"
          :key="service.id"
        ></service-list-item>
      </div>
    </div>
    <div class="grid-summary">
      <div>
        <p>ราคาแพ็คแกจ</p>
        <el-input :value="packagePrice" type="text" readonly />
      </div>
      <div>
        <p>จำนวนการซื้อแพ็คเกจ</p>
        <el-input v-model="quality" type="number" min="1" />
      </div>
      <div v-if="data && data.packageId && value.canUseCoupon">
        <p>Code ส่วนลด</p>
        <coupon-select
          :packageId="data.packageId"
          :value="coupon"
          @selectCoupon="handleChangeCoupon"
        ></coupon-select>
      </div>
      <div v-if="value.canUseCoupon">
        <p>ส่วนลดจาก Code</p>
        <el-input v-model="discountAmount" readonly />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-2 price">
        <p>ราคาสุทธิ</p>
        <el-input type="text" v-model="totalPrice" readonly />
      </div>
      <div class="col-3 price" v-if="value.canUseCoupon">
        <el-checkbox
          :value="isWithholding"
          @input="handleSelectWithholding($event)"
        ></el-checkbox>
        มีหัก ณ ที่จ่าย
        <el-input type="text" :value="totalPriceWithholding" readonly/>
      </div>
    </div>
  </div>
</template>

<script>
import { Radio as ElRadio, Checkbox, Input } from "element-ui";
import ServiceListItem from "../../services/components/ServiceListItem";
import CouponSelect from "@/lib/components/CouponSelect";
import {
  formatDecimal,
  convertBathToStangAndRoundTwoDecimal
} from "@/lib/formatter";

export default {
  props: ["value", "data", "coupon"],
  components: {
    ElRadio,
    "el-checkbox": Checkbox,
    ServiceListItem,
    "el-input": Input,
    CouponSelect,
  },
  data() {
    return {
      packagePrice: null,
      totalPrice: null,
      discountAmount: null,
      quality: 1,
    };
  },
  computed: {
    packageOptions() {
      return this.value.packageOptions;
    },
    services() {
      if (!this.data || !this.data.services) return []

      const services = this.data.services.map((service) => {
        let serviceOptions = [];
        let serviceOptionPrices = [];
        this.value.packageOptions.forEach((serviceOption, indexServiceOption) => {
          if (serviceOption.serviceId === +service.id) {
            if (serviceOption.servicePrice) {
              serviceOptionPrices[indexServiceOption] = +serviceOption.servicePrice;
            }

            if (
              serviceOption.serviceVariants &&
              serviceOption.serviceVariants.length > 0
            ) {
              serviceOption.serviceVariants.forEach((serviceVariant) => {
                if (serviceVariant.variants.length > 0) {
                  serviceVariant.variants.forEach((variant, indexVariant) => {
                    if (variant.isVaraintSelected) {
                      serviceOptions[indexVariant] = variant.title;
                      serviceOptionPrices[indexVariant] = +variant.price;
                    }
                  });
                }
              });
            }
          }
        });

        const servicePrices = serviceOptionPrices.length > 0
          ? serviceOptionPrices.reduce((sum, current) => sum + current, 0)
          : undefined;

        const mainOption = serviceOptions.length > 0 ? serviceOptions[0] : undefined;

        if (serviceOptions.length > 0) {
          serviceOptions.shift();
        }

        const extraOption = serviceOptions.length > 0
          ? serviceOptions.toString()
          : undefined;

        return {
          id: service.id,
          name: service.name,
          shortDescription: service.shortDescription,
          description: service.description,
          provider: service.provider,
          servicePrices,
          mainOption,
          extraOption,
        };
      });

      const packagePrice = services.map(
        (service) => service.servicePrices
      ).reduce((sum, current) => sum + current, 0);

      this.packagePrice = isNaN(packagePrice)
        ? this.data.packagePrice
        : packagePrice;

      return services;
    },
    isWithholding() {
      return this.value.isWithholding;
    },
    totalPriceWithholding() {
      return this.value.totalPriceWithholding;
    }
  },
  methods: {
    handleSelectExtraVariant(event, serviceId, serviceVariantId, variantId) {
      this.value.packageOptions.map((serviceOption) => {
        if (serviceOption.serviceId === serviceId) {
          serviceOption.serviceVariants.map((serviceVariant) => {
            if (serviceVariant.id === serviceVariantId) {
              serviceVariant.variants.map((variant,variantIndex) => {
                if (variant.id === variantId) {
                  variant.isVaraintSelected = event;

                  if (event) {
                    this.value.extraOptionSelected.push({
                      isExtraOption: variant.isExtraOption,
                      price: variant.price,
                      title: variant.title,
                      id: variant.id,
                      isVaraintSelected: variant.isVaraintSelected,
                      isNotSale: variant.isNotSale,
                      serviceId: serviceOption.serviceId
                    })
                  } else {
                    const extraOptionIndex = this.value.extraOptionSelected.findIndex(
                      item => item.id === variant.id
                    );

                    this.value.extraOptionSelected.splice(extraOptionIndex, 1);
                  }
                }
              });
            }
          });
        }
      });

      this.$emit("input", {
        ...this.value,
        packageOptions: this.value.packageOptions,
        extraOptionSelected: this.value.extraOptionSelected
      });
    },
    handleSelectMainVariant(serviceId, serviceVariantId, variantId) {
      this.value.packageOptions.map((serviceOption, serviceOptionIndex) => {
        if (serviceOption.serviceId === serviceId) {
          serviceOption.serviceVariants.map((serviceVariant) => {
            if (serviceVariant.id === serviceVariantId) {
              serviceVariant.variants.map((variant) => {
                if (variant.id === variantId) {
                  variant.isVaraintSelected = true;

                  this.value.mainOptionSelected[serviceOptionIndex] = {
                    isExtraOption: variant.isExtraOption,
                    price: variant.price,
                    title: variant.title,
                    id: variant.id,
                    isVaraintSelected: variant.isVaraintSelected,
                    isNotSale: variant.isNotSale,
                    serviceId: serviceOption.serviceId
                  }
                }
              });
            } else {
              serviceVariant.variants.map((variant) => {
                if (variant.id !== variantId) {
                  variant.isVaraintSelected = false;
                }
              });
            }
          });
        }
      });

      this.$emit("input", {
        ...this.value,
        packageOptions: this.value.packageOptions,
        mainOptionSelected: this.value.mainOptionSelected
      });
    },
    handleChangeCoupon(coupon) {
      if (!coupon) {
        this.$emit("selectCoupon", null);
        this.discountAmount = null;
        return;
      }

      this.$emit("selectCoupon", coupon);

      if (coupon.discount_amount) {
        this.discountAmount = convertBathToStangAndRoundTwoDecimal(coupon.discount_amount);
      } else {
        let actualDiscountAmount = formatDecimal(
          convertBathToStangAndRoundTwoDecimal(coupon.discount_percent_amount) *
            (this.packagePrice * this.quality)
        );

        const rawMaxDiscountAmount = coupon.maximum_discount_amount
        const maxDiscountAmount = rawMaxDiscountAmount
          ? convertBathToStangAndRoundTwoDecimal(rawMaxDiscountAmount)
          : null;

        if (maxDiscountAmount && actualDiscountAmount > maxDiscountAmount) {
          actualDiscountAmount = maxDiscountAmount;
        }

        this.discountAmount = actualDiscountAmount;
      }

      this.totalPrice = (this.packagePrice * this.quality) > this.discountAmount
        ? (this.packagePrice * this.quality) - this.discountAmount
        : 0

      this.$emit("input", {
        ...this.value,
        discountAmount: this.discountAmount,
        totalPrice: this.totalPrice
      });
    },
    handleSelectWithholding(value) {
      const total = this.totalPrice;

      let totalPriceWithholding = null;
      if (value === true) {
        const priceExcludeVat = formatDecimal(total * 100 / 107) || 0

        const priceVatAndWithholding = priceExcludeVat
          ? formatDecimal(total - (formatDecimal(priceExcludeVat * 0.03) || 0))
          : 0

        totalPriceWithholding = formatDecimal(priceVatAndWithholding) || 0;
      }

      this.$emit("input", {
        ...this.value,
        isWithholding: value,
        totalPriceWithholding
      });
    }
  },
  watch: {
    packagePrice(packagePriceChanging) {
      if (this.coupon) {
        this.totalPrice = this.packagePrice > this.discountAmount
          ? this.packagePrice - this.discountAmount
          : 0
      } else {
        this.totalPrice = packagePriceChanging;
      }

      this.$emit("input", {
        ...this.value,
        totalPrice: this.totalPrice,
        packagePrice: packagePriceChanging
      });
    },
    quality(newValue, oldValue) {
      this.totalPrice = this.packagePrice * +newValue;

      if (!newValue) return undefined;

      if (newValue === "0") {
        alert("ไม่สามารถกำหนดจำนวนแพ็คเกจเป็น 0 ได้");
        this.$emit("input", {...this.value, quality: oldValue });

        return (this.quality = oldValue);
      }

      if (this.coupon) {
        if (this.coupon.discount_percent_amount) {
          this.discountAmount = formatDecimal((this.coupon.discount_percent_amount / 100) * this.totalPrice);
        }

        this.totalPrice = (this.packagePrice * +newValue) > this.discountAmount
          ? formatDecimal((this.packagePrice * +newValue) - this.discountAmount)
          : 0;
      }

      this.$emit("input", {
        ...this.value,
        quality: newValue,
        totalPrice: this.totalPrice,
        discountAmount: this.discountAmount
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.list-option {
  display: grid;
  grid-template-columns: 470px auto;
  height: auto;
}

.service-option {
  border: $border-head;
  height: 50px;
  background-color: #f2f2f2;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;

  display: grid;
  grid-template-columns: 350px 120px;
}

.grid-price {
  display: grid;
  grid-template-columns: 350px 120px;
}

.title {
  &-option {
    border-right: $border;
    padding-left: 10px;
    padding-top: 10px;
    font-size: 15px;
    font-weight: normal;
  }

  &-option-head {
    padding: 10px;
    font-size: 18px;
    font-weight: bold;
  }

  &-option-detail {
    font-size: 15px;
    font-weight: normal;
  }

  &-option-price {
    padding: 10px;
    font-size: 15px;
    font-weight: normal;
  }

  &-head-package {
    padding-left: 20px;

    font-size: 20px;
    font-weight: bold;
  }
}

.group-option {
  border: $border-head;
  border-top: 0;

  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.service-variant {
  padding-left: 10px;
}

.checkbox-variant {
  padding-left: 15px;
}

.radio-option {
  transform: scale(1.25);
  margin-right: 15px;
  margin-bottom: 10px;
}

.grid-summary {
  padding-top: 20px;
  display: grid;
  grid-template-columns: auto auto auto auto;
  grid-gap: 20px;
}

.price {
  width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/features/subscriptions/modules/subscribers/components/ServiceOptionOfflinePurchase.vue